var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideocallHangupIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 188,
    viewBox: "0 0 184 188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(-556 711)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 184,
    height: 188,
    transform: "translate(556 -711)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-call-end",
    "data-name": "Icon material-call-end",
    d: "M91.78,25.8A114.043,114.043,0,0,0,56.6,31.3v23.71A7.706,7.706,0,0,1,52.315,61.9,88.04,88.04,0,0,0,31.97,76.046a7.511,7.511,0,0,1-5.354,2.142,7.624,7.624,0,0,1-5.43-2.218L2.218,57A7.315,7.315,0,0,1,0,51.648a7.624,7.624,0,0,1,2.218-5.43,130.147,130.147,0,0,1,179.124,0,7.756,7.756,0,0,1,0,10.861L162.374,76.046a7.624,7.624,0,0,1-5.43,2.218,7.848,7.848,0,0,1-5.354-2.142,86.2,86.2,0,0,0-20.421-14.149,7.62,7.62,0,0,1-4.283-6.884V31.38A111.02,111.02,0,0,0,91.78,25.8Z",
    transform: "translate(556.22 -661.382)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocallHangupIcon);
export default __webpack_public_path__ + "static/media/videocall-hangup-icon.61d2eac6a8fa18cf22173c419895a595.svg";
export { ForwardRef as ReactComponent };